// Content constants: rich editorial copy for markets and Learning Center articles.
// These live in code for the MVP; Phase 4 will migrate to DB-backed CMS.

export const LOGO = {
  wordmarkFull: "https://customer-assets-cm19k8pv.emergentagent.net/job_43abeb8b-6760-4327-a5d6-e572877f65c6/artifacts/rqmuleby_Altura%20logo_Real%20Esrate-03.png",
  wordmarkAlt: "https://customer-assets-cm19k8pv.emergentagent.net/job_43abeb8b-6760-4327-a5d6-e572877f65c6/artifacts/oijgztwz_Altura%20logo_Real%20Esrate-02.png",
  iconOnly: "https://customer-assets-cm19k8pv.emergentagent.net/job_43abeb8b-6760-4327-a5d6-e572877f65c6/artifacts/a2hr7iav_Altura%20logo_Real%20Esrate-07.png",
  wordmarkOnly: "https://customer-assets-cm19k8pv.emergentagent.net/job_43abeb8b-6760-4327-a5d6-e572877f65c6/artifacts/gxmmikan_Altura%20logo_Real%20Esrate-04.png",
  globalLink: "https://customer-assets-cm19k8pv.emergentagent.net/job_43abeb8b-6760-4327-a5d6-e572877f65c6/artifacts/fa2dtxz6_Altura%20logo_Real%20Esrate-01.png",
};

export const HERO_ROTATION = [
  { image: "https://images.pexels.com/photos/32803403/pexels-photo-32803403.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600", label: "Accra, Ghana", flagship: true },
  { image: "https://images.pexels.com/photos/19612315/pexels-photo-19612315.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600", label: "Downtown Dubai" },
  { image: "https://images.unsplash.com/photo-1549109768-246d46377b25?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600", label: "Punta Cana" },
  { image: "https://images.unsplash.com/photo-1730453255648-af776b331035?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600", label: "Ghana coastline" },
  { image: "https://images.unsplash.com/photo-1596005554384-d293674c91d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600", label: "Nairobi" },
  { image: "https://images.unsplash.com/photo-1577315734214-4b3dec92d9ad?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600", label: "Zanzibar, Tanzania" },
];

export const MARKETS_COPY = {
  ghana: {
    slug: "ghana",
    name: "Ghana",
    country: "Ghana",
    flag: "🇬🇭",
    is_flagship: true,
    hero: "https://images.pexels.com/photos/32803403/pexels-photo-32803403.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1900",
    intro: "Our flagship market. Ghana anchors the Altura Global thesis: a politically stable, English-speaking economy welcoming diaspora capital, entrepreneurship, and long-hold real estate.",
    tagline: "The heart of Altura Global.",
    key_areas: ["Accra — Cantonments, Airport Residential, East Legon", "Tema — Coastal industrial corridor", "Kumasi — Ashanti heritage capital", "Takoradi — Western oil & gas hub"],
    why_points: [
      { title: "Political & economic stability", body: "One of West Africa's most stable democracies with a growing middle class and diaspora inflows." },
      { title: "Diaspora returning home", body: "A cultural and economic homecoming: Ghana's Year of Return catalyzed a permanent wave of diaspora settlement and investment." },
      { title: "English-speaking & investor friendly", body: "Common-law inheritance, English administration, and clear diaspora property pathways." },
      { title: "Coastal, urban, and land diversity", body: "From beachfront villas to titled land parcels, Ghana offers a full spectrum of investment shapes." },
    ],
    property_types: ["Residential", "Luxury", "Land", "Commercial", "New Developments", "Vacation Property", "Business Opportunity"],
    faqs: [
      { q: "Can non-Ghanaians own property in Ghana?", a: "Yes — foreign nationals and diaspora buyers can acquire property, most commonly through leasehold structures for land. Titled freehold conditions vary by region and use; Altura Global helps clients understand the appropriate structure for each opportunity." },
      { q: "What is the typical buying process?", a: "It starts with a consultation to understand your objectives, followed by curated matching, physical or virtual tours, due diligence, and closing coordination through licensed local counsel." },
      { q: "Does Altura Global provide legal or tax advice?", a: "No. We connect you with vetted, licensed local professionals for legal, tax, and financing matters. Altura Global provides investment guidance and coordination, not licensed advice." },
    ],
  },
  kenya: {
    slug: "kenya", name: "Kenya", country: "Kenya", flag: "🇰🇪",
    hero: "https://images.unsplash.com/photo-1596005554384-d293674c91d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1900",
    intro: "East Africa's commercial capital. Nairobi combines a maturing financial services sector, a global tech scene, and highland lifestyle real estate.",
    key_areas: ["Nairobi — Karen, Runda, Kilimani", "Nanyuki — Mount Kenya lifestyle", "Diani — Coastal resort & rental"],
    why_points: [
      { title: "Regional business hub", body: "Nairobi anchors East Africa's financial, tech, and NGO ecosystems." },
      { title: "Lifestyle diversity", body: "From leafy suburbs to coastal escapes and highland ranches." },
      { title: "Strong rental market", body: "Corporate and diplomatic tenants create durable rental demand." },
    ],
    property_types: ["Residential", "Luxury", "Land", "Vacation Property", "Commercial"],
    faqs: [
      { q: "How does foreign ownership work in Kenya?", a: "Foreigners can own residential property on leasehold (typically 99-year). Agricultural land has specific restrictions. We coordinate with licensed local counsel." },
    ],
  },
  nigeria: {
    slug: "nigeria", name: "Nigeria", country: "Nigeria", flag: "🇳🇬",
    hero: "https://images.pexels.com/photos/37405043/pexels-photo-37405043.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1900",
    intro: "Africa's largest economy. Lagos concentrates commerce, culture, and a rapidly urbanizing appetite for premium residences and business assets.",
    key_areas: ["Lagos — Ikoyi, Victoria Island, Lekki", "Abuja — Government capital", "Port Harcourt — Energy hub"],
    why_points: [
      { title: "Scale", body: "The continent's largest population and consumer market." },
      { title: "Diaspora demand", body: "A significant Nigerian diaspora fuels sustained demand for Lagos premium residences." },
      { title: "Business opportunity", body: "Owner-occupied commercial and mixed-use assets remain undersupplied." },
    ],
    property_types: ["Residential", "Luxury", "Commercial", "Business Opportunity", "Land"],
    faqs: [{ q: "Is Nigeria safe for property investment?", a: "Successful investment requires local expertise, licensed counsel, and rigorous title diligence. Altura Global coordinates trusted local partners on every transaction." }],
  },
  tanzania: {
    slug: "tanzania", name: "Tanzania", country: "Tanzania", flag: "🇹🇿",
    hero: "https://images.unsplash.com/photo-1577315734214-4b3dec92d9ad?crop=entropy&cs=srgb&fm=jpg&q=85&w=1900",
    intro: "East Africa's coastal jewel. Dar es Salaam anchors commerce; Zanzibar delivers Indian Ocean vacation-property investment with growing tourism yields.",
    key_areas: ["Dar es Salaam — Masaki, Oyster Bay", "Zanzibar — Kiwengwa, Nungwi, Paje", "Arusha — Safari gateway"],
    why_points: [
      { title: "Zanzibar tourism growth", body: "A rising Indian Ocean destination for European and Middle Eastern travelers." },
      { title: "Coastal vacation property", body: "Beachfront villas with managed rental yields." },
      { title: "Diversifying economy", body: "Tourism, agriculture, and gas offer varied investment shapes." },
    ],
    property_types: ["Vacation Property", "Luxury", "Land", "Residential"],
    faqs: [{ q: "Can foreigners buy in Zanzibar?", a: "Zanzibar operates distinct property regulations from mainland Tanzania. Certain investor programs enable foreign ownership through approved developments; we coordinate specifics on each opportunity." }],
  },
  dubai: {
    slug: "dubai", name: "Dubai", country: "Dubai", flag: "🇦🇪",
    hero: "https://images.pexels.com/photos/19612315/pexels-photo-19612315.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1900",
    intro: "A global financial hub with a mature, transparent property market. Dubai remains a cornerstone destination for international investors seeking currency stability and yield.",
    key_areas: ["Downtown", "Palm Jumeirah", "Dubai Marina", "Business Bay", "Emirates Hills"],
    why_points: [
      { title: "Currency & tax posture", body: "Zero property tax on ownership; USD-pegged AED provides currency stability." },
      { title: "Yield & tourism", body: "Strong short-term rental yields via a mature holiday-let market." },
      { title: "Transparency", body: "Regulated brokerage, escrow, and title registration." },
    ],
    property_types: ["Luxury", "Residential", "New Developments", "Vacation Property", "Commercial"],
    faqs: [{ q: "Can foreigners own property in Dubai?", a: "Yes — freehold ownership is available to foreigners in designated freehold zones. Altura Global focuses on curated freehold opportunities in premium districts." }],
  },
  punta_cana: {
    slug: "punta_cana", name: "Punta Cana", country: "Punta Cana", flag: "🇩🇴",
    hero: "https://images.unsplash.com/photo-1549109768-246d46377b25?crop=entropy&cs=srgb&fm=jpg&q=85&w=1900",
    intro: "The Caribbean's flagship vacation-property market. Punta Cana combines beachfront lifestyle with mature rental infrastructure and USD-denominated pricing.",
    key_areas: ["Cap Cana", "Bavaro", "Punta Cana Village", "Cocotal Golf Community"],
    why_points: [
      { title: "USD pricing & rental yields", body: "Mature managed-rental programs and USD transactions." },
      { title: "Direct flights", body: "Punta Cana International connects to North America, Europe, and Latin America." },
      { title: "Lifestyle infrastructure", body: "Golf, beach clubs, and boutique dining tailored to international owners." },
    ],
    property_types: ["Vacation Property", "Luxury", "New Developments", "Residential"],
    faqs: [{ q: "Is DR foreign-ownership friendly?", a: "Yes. The Dominican Republic allows foreign ownership under the same terms as citizens. Confianza Solidaria and CONFOTUR incentives may apply to qualifying tourism-development purchases." }],
  },
};

export const MARKETS_LIST = ["ghana", "kenya", "nigeria", "tanzania", "dubai", "punta_cana"].map((k) => MARKETS_COPY[k]);

export const INVESTMENT_CATEGORIES = [
  { key: "residential", label: "Residential", body: "Primary residences and family homes across curated global neighborhoods.", image: "https://images.pexels.com/photos/18285958/pexels-photo-18285958.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { key: "commercial", label: "Commercial", body: "Owner-occupied and income-producing commercial assets.", image: "https://images.pexels.com/photos/32803403/pexels-photo-32803403.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { key: "land", label: "Land", body: "Titled land parcels for long-term appreciation and development.", image: "https://images.unsplash.com/photo-1730453255648-af776b331035?crop=entropy&cs=srgb&fm=jpg&q=85&w=940" },
  { key: "luxury", label: "Luxury", body: "Signature residences with architectural provenance.", image: "https://images.pexels.com/photos/20418771/pexels-photo-20418771.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { key: "vacation", label: "Vacation Property", body: "Managed-rental beach and resort residences.", image: "https://images.unsplash.com/photo-1549109768-246d46377b25?crop=entropy&cs=srgb&fm=jpg&q=85&w=940" },
  { key: "new_development", label: "New Developments", body: "Pre-construction opportunities from vetted developers.", image: "https://images.pexels.com/photos/19612315/pexels-photo-19612315.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { key: "business", label: "Business Opportunities", body: "Operating businesses and franchise pathways.", image: "https://images.unsplash.com/photo-1778731525532-d2ab833c8463?crop=entropy&cs=srgb&fm=jpg&q=85&w=940" },
];

export const WHY_ALTURA = [
  { title: "Ghana specialization", body: "Deep, on-the-ground focus on Ghana as our flagship market — with the relationships to match." },
  { title: "Curated global perspective", body: "A restrained portfolio of international destinations selected for stability and long-term merit." },
  { title: "Education first", body: "We help you understand before we invite you to consider. No pressure, no gimmicks." },
  { title: "Trusted partnerships", body: "Developer, legal, and lifestyle partners vetted for integrity and delivery." },
  { title: "Premium client experience", body: "Concierge-style guidance across every touchpoint of your investment journey." },
  { title: "International network", body: "Diaspora and cross-border investors served with cultural fluency." },
];

export const ARTICLES = [
  {
    slug: "why-ghana-global-investment-destination",
    title: "Why Ghana Is Becoming a Global Investment Destination",
    excerpt: "A quietly confident economy, an English-speaking legal system, and a diaspora coming home have positioned Ghana as one of Africa's most compelling investment destinations.",
    category: "Ghana Investment",
    market: "Ghana",
    reading_time: "6 min read",
    date: "2026-01-14",
    image: "https://images.pexels.com/photos/32803403/pexels-photo-32803403.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    body: [
      "Every generation, a small handful of markets crosses the line from emerging to essential. Ghana is quietly making that crossing. For international investors and members of the African diaspora, the country now offers a rare combination: political stability, English-common-law inheritance, USD-friendly pricing on many premium assets, and a cultural momentum that few markets can match.",
      "The last decade's Year of Return catalyzed something more permanent than a tourism season — it turned a wave of diaspora curiosity into a durable movement of returning capital, entrepreneurship, and settlement. Neighborhoods like Cantonments, Airport Residential, and East Legon have absorbed that demand into a new generation of architecturally serious residences, master-planned communities, and mixed-use lifestyle projects.",
      "Ghana rewards patience. The country is not a short-term flip market. It rewards those who understand the arc — legal diligence, developer relationships, and long-hold appreciation aligned with a maturing economy. That is precisely the kind of investment Altura Global was built to support.",
    ],
  },
  {
    slug: "buying-property-in-ghana-beginners-guide",
    title: "Buying Property in Ghana: A Beginner's Guide",
    excerpt: "From title diligence to the buying process — a straightforward introduction for international buyers considering their first property in Ghana.",
    category: "Buying Guide", market: "Ghana", reading_time: "8 min read", date: "2026-01-08",
    image: "https://images.pexels.com/photos/18285958/pexels-photo-18285958.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    body: [
      "The Ghanaian property market operates on English common-law foundations, which is a comfort for many international buyers. That said, land and property acquisition in Ghana requires care — and the specifics vary by region, land type (state, stool/family, private), and intended use.",
      "A typical buying journey with Altura Global looks like this: an initial consultation to understand your objectives, a curated shortlist of matching opportunities, physical or virtual tours, licensed legal counsel for title verification, an escrowed payment structure, and closing coordination.",
      "This article is educational only and not a substitute for licensed legal, tax, or immigration advice. Altura Global coordinates directly with vetted local professionals on every transaction.",
    ],
  },
  {
    slug: "land-investment-opportunities-ghana",
    title: "Exploring Land Investment Opportunities in Ghana",
    excerpt: "Land is the quiet compounding engine of Ghana's investment story. Here's how to think about it — and what to look for.",
    category: "Ghana Investment", market: "Ghana", reading_time: "5 min read", date: "2025-12-19",
    image: "https://images.unsplash.com/photo-1730453255648-af776b331035?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
    body: [
      "For patient investors, land in Ghana is one of the region's most compelling long-hold plays. Titled parcels along the coastal corridor, urban infill within Accra's inner ring, and select Ashanti-region opportunities have delivered durable appreciation over the past decade.",
      "The word 'titled' matters. Altura Global works exclusively with parcels that have clean title diligence completed through licensed counsel — nothing less. Our role is to help you understand what you are looking at, what it means legally, and whether it fits your investment thesis.",
    ],
  },
  {
    slug: "international-real-estate-investing-fundamentals",
    title: "International Real Estate Investing: What Buyers Should Understand",
    excerpt: "Owning property across borders is different. Currency, tax posture, and local legal systems all shape outcomes. Here's a straightforward primer.",
    category: "Education", market: null, reading_time: "7 min read", date: "2025-12-12",
    image: "https://images.pexels.com/photos/20418771/pexels-photo-20418771.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    body: [
      "Cross-border property investing is not simply domestic investing with a passport. Currency exposure, jurisdictional legal structure, remote asset management, and tax reporting obligations in both the country of purchase and your country of tax residence all shape outcomes.",
      "The good news: with the right advisors and disciplined diligence, international real estate can be a durable, generational-wealth-building asset class. Altura Global helps you understand the landscape and coordinate the licensed professionals you need.",
    ],
  },
  {
    slug: "exploring-property-opportunities-dubai",
    title: "Exploring Property Opportunities in Dubai",
    excerpt: "A global financial hub with mature title infrastructure, currency stability, and mature short-term-rental yields. Dubai remains a cornerstone market.",
    category: "Dubai", market: "Dubai", reading_time: "6 min read", date: "2025-11-30",
    image: "https://images.pexels.com/photos/19612315/pexels-photo-19612315.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    body: [
      "Dubai is a market that rewards clarity. Its property system is regulated, transparent, and open to foreign ownership within designated freehold zones. Escrow protections, RERA registration, and mature developer relationships create a system that feels closer to Singapore or London than to many emerging markets.",
      "Altura Global's Dubai focus is curated. We work with a small set of trusted freehold opportunities in Downtown, Palm Jumeirah, and Dubai Marina — favoring assets that combine architectural provenance with genuine short-term-rental utility.",
    ],
  },
  {
    slug: "kenyas-emerging-real-estate-landscape",
    title: "Kenya's Emerging Real Estate Landscape",
    excerpt: "East Africa's commercial capital has quietly matured into a diversified investment market. Here's the shape of it.",
    category: "Kenya", market: "Kenya", reading_time: "5 min read", date: "2025-11-14",
    image: "https://images.unsplash.com/photo-1596005554384-d293674c91d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
    body: [
      "Nairobi is a genuinely regional capital. Its financial sector, tech ecosystem, and NGO presence create a durable base of demand for residential leasing, office space, and boutique retail. Beyond Nairobi, Kenya offers lifestyle-property alternatives in the highlands and along the coast.",
      "For international buyers, Kenya operates on a leasehold basis (typically 99-year for foreigners). We coordinate title, tax, and immigration counsel through licensed local partners.",
    ],
  },
  {
    slug: "punta-cana-lifestyle-property-considerations",
    title: "Punta Cana: Lifestyle Property and Investment Considerations",
    excerpt: "The Caribbean's flagship vacation-property market — mature rental infrastructure, USD pricing, and direct-flight accessibility.",
    category: "Punta Cana", market: "Punta Cana", reading_time: "5 min read", date: "2025-10-22",
    image: "https://images.unsplash.com/photo-1641957991880-8f2714e8acf3?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
    body: [
      "Punta Cana has matured into a genuine cornerstone of Caribbean vacation-property investment. Direct flights from major North American, European, and Latin American cities create a broad, consistent rental demand base — one that many resort markets simply cannot claim.",
      "The Dominican Republic welcomes foreign ownership under the same terms as citizens, and select tourism-development programs may offer additional incentives on qualifying purchases.",
    ],
  },
  {
    slug: "prepare-for-international-property-consultation",
    title: "How to Prepare for an International Property Consultation",
    excerpt: "What to think about before your first conversation with Altura Global. A short, practical guide.",
    category: "Getting Started", market: null, reading_time: "4 min read", date: "2025-10-05",
    image: "https://images.pexels.com/photos/20418771/pexels-photo-20418771.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    body: [
      "The most productive consultations begin with clarity. Before your first conversation with an Altura Global advisor, spend a few minutes considering your objectives, your timeline, your budget shape, and any markets you are drawn to.",
      "You do not need answers to every question — that is what the consultation is for. But approximate direction helps us bring you the right context, the right shortlist, and the right introductions to licensed local professionals.",
    ],
  },
];

export const RESOURCE_CATEGORIES = [
  { key: "all", label: "All Resources" },
  { key: "investment_guides", label: "Investment Guides" },
  { key: "checklists", label: "Checklists" },
  { key: "country_guides", label: "Country Guides" },
];

// Cover art comes from user-uploaded assets. Resources whose `download_url` is
// null are hidden from the public site (Task 4 — auto-map by filename once the
// PDF is uploaded, then flip download_url to the CDN URL to publish the card).
export const RESOURCES = [
  {
    key: "starter_guide",
    slug: "global-investment-starter-guide",
    title: "The Global Investment Starter Guide",
    category: "investment_guides",
    category_label: "Investment Guide",
    type: "Flyer",
    visibility: "gated",
    reading_time: "8 min read",
    file_size_mb: 1.9,
    pdf_filename: "The Global Investment Starter Guide.png",
    download_url: "https://customer-assets-4nw71qhi.emergentagent.net/job_invest-beyond-2/artifacts/eltldxur_The%20Global%20Investment%20Starter%20Guide.png",
    image: "https://customer-assets-4nw71qhi.emergentagent.net/job_invest-beyond-2/artifacts/eltldxur_The%20Global%20Investment%20Starter%20Guide.png",
    description: "A foundational primer for investors considering their first international real-estate opportunity.",
    long_description: "The Global Investment Starter Guide is a foundational primer for anyone considering international real estate for the first time. Learn how to evaluate markets, understand cross-border ownership structures, and structure your first successful acquisition with clarity and confidence.",
    related_keys: ["ghana_guide", "diaspora_checklist"],
  },
  {
    key: "ghana_guide",
    slug: "ghana-investment-guide",
    title: "Ghana Investment Guide",
    category: "country_guides",
    category_label: "Country Guide",
    type: "PDF",
    visibility: "gated",
    reading_time: "24 min read",
    file_size_mb: 50.7,
    pdf_filename: "Altura Global RE Ghana Investment Guide.pdf",
    download_url: "https://customer-assets-4nw71qhi.emergentagent.net/job_invest-beyond-2/artifacts/dvst8iax_Altura%20Global%20RE%20Ghana%20Investment%20Guide.pdf",
    image: "https://images.pexels.com/photos/32803403/pexels-photo-32803403.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1200",
    description: "Everything a diaspora investor should understand about Ghana's opportunity landscape, buying process, and lifestyle.",
    long_description: "Our flagship-market guide. Everything a diaspora or international investor should understand about Ghana's opportunity landscape — from Accra's premier neighborhoods to titled land, coastal vacation property, and the buying process. Prepared by Altura Global RE.",
    related_keys: ["diaspora_checklist", "starter_guide"],
  },
  {
    key: "diaspora_checklist",
    slug: "diaspora-buyers-checklist",
    title: "The Diaspora Buyer's Checklist",
    category: "checklists",
    category_label: "Checklist",
    type: "Flyer",
    visibility: "gated",
    reading_time: "4 min read",
    file_size_mb: 1.6,
    pdf_filename: "The Diaspora Buyer's Checklist.png",
    download_url: "https://customer-assets-4nw71qhi.emergentagent.net/job_invest-beyond-2/artifacts/vcoi1ygw_The%20Diaspora%20Buyer%27s%20Checklist.png",
    image: "https://customer-assets-4nw71qhi.emergentagent.net/job_invest-beyond-2/artifacts/vcoi1ygw_The%20Diaspora%20Buyer%27s%20Checklist.png",
    description: "A one-page checklist of key considerations for diaspora investors evaluating property abroad.",
    long_description: "A concise, printable checklist that walks diaspora investors through the essential considerations before making an international property purchase — title verification, remote diligence, currency, tax, and coordination.",
    related_keys: ["ghana_guide", "global_growth_checklist"],
  },
  {
    key: "global_growth_checklist",
    slug: "global-growth-checklist",
    title: "Global Growth Checklist",
    category: "checklists",
    category_label: "Checklist",
    type: "Flyer",
    visibility: "gated",
    reading_time: "5 min read",
    file_size_mb: 1.8,
    pdf_filename: "Global Growth Checklist.png",
    download_url: "https://customer-assets-4nw71qhi.emergentagent.net/job_invest-beyond-2/artifacts/cd91hywq_Global%20Growth%20Checklist.png",
    image: "https://customer-assets-4nw71qhi.emergentagent.net/job_invest-beyond-2/artifacts/cd91hywq_Global%20Growth%20Checklist.png",
    description: "A concise checklist for scaling an international real-estate portfolio the Altura Global way.",
    long_description: "The Global Growth Checklist condenses the Altura Global approach to scaling an international portfolio into a single, actionable reference. Cover markets, structures, coordination, and long-hold discipline.",
    related_keys: ["diaspora_checklist", "starter_guide"],
  },
  {
    key: "dubai_guide",
    slug: "dubai-investors-overview",
    title: "Dubai: An Investor's Overview",
    category: "country_guides",
    category_label: "Country Guide",
    type: "Flyer",
    visibility: "gated",
    reading_time: "6 min read",
    file_size_mb: 1.8,
    pdf_filename: "Dubai An Investor's Overview.png",
    download_url: "https://customer-assets-4nw71qhi.emergentagent.net/job_invest-beyond-2/artifacts/pgdocykm_Dubai%20An%20Investor%27s%20Overview.png",
    image: "https://customer-assets-4nw71qhi.emergentagent.net/job_invest-beyond-2/artifacts/pgdocykm_Dubai%20An%20Investor%27s%20Overview.png",
    description: "A concise overview of Dubai's freehold zones, tax posture, and premium districts.",
    long_description: "Dubai remains a cornerstone of international real-estate investment. This concise overview walks through freehold zones, currency and tax posture, premium districts, and Altura Global's curated approach.",
    related_keys: ["starter_guide", "diaspora_checklist"],
  },
];

export const BUSINESS_INFO = {
  legal_name: "Altura Property Group, DBA Altura Global RE",
  brand: "Altura Global",
  tagline: "Invest Beyond Borders.",
  mission: "To provide transparent, profitable, and seamless real estate experiences globally, empowering you to grow your real estate portfolio anywhere in the world.",
  email_primary: "alturaglobalre@gmail.com",
  email_secondary: "alturapropertygroup@gmail.com",
  email_display: "info@alturagroupre.com",
  phone_usa: "(917) 243-3061",
  phone_global: "(404) 990-8917",
  address: "9951 Atlantic Blvd. Ste 443, Jacksonville, FL 32225",
  address_location_note: "USA Mailing Address · Serving clients globally with Ghana as our flagship market.",
  hours: [
    { label: "Monday – Friday", value: "9:00 AM – 6:00 PM" },
    { label: "Saturday", value: "9:00 AM – 12:00 PM" },
    { label: "Sunday", value: "By appointment only" },
  ],
  global_link_commission: "$250 for every closed sale",
  socials: {
    facebook: "https://www.facebook.com/AlturaGlobalRE/",
    instagram: "https://www.instagram.com/alturaglobalre",
  },
  founder: {
    name: "Ima Wallace",
    title: "Founder & International Real Estate Agent",
    bio: "Altura Global was founded by Ima Wallace, an International Real Estate Agent and global investor committed to empowering clients to build legacy wealth through real estate. With years of experience, strategic partnerships, and local market experts on the ground, we help clients confidently navigate property transactions across borders.",
  },
  stats: [
    { value: "30+", label: "Properties Sold" },
    { value: "200+", label: "Happy Clients" },
    { value: "5+", label: "Countries Covered" },
    { value: "10+", label: "Industry Awards" },
  ],
};


export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Explore Ghana", to: "/explore-ghana" },
  { label: "Markets", to: "/markets", dropdown: true },
  { label: "Opportunities", to: "/opportunities" },
  { label: "Learning Center", to: "/learning-center" },
  { label: "Resources", to: "/resources" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];
